module.exports = "<div class=\"icon vg-icon-cast\" [class.idle]=\"!isCasting\" [class.connected]=\"isCasting\" (click)=\"toggleCasting()\" ></div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-player/vg-chromecast/vg-chromecast.media/vg-chromecast.media.component.html
// module id = 832
// module chunks = 2